// extracted by mini-css-extract-plugin
module.exports = {"heading":"general_heading__csGse","notTop":"general_notTop__UFgw4","noMorePostText":"general_noMorePostText__nFN6k"};